import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ name: "MAlert", namespaced: true })
export default class MAlert extends VuexModule {
  alertSuccess = false;
  alertError = false;

  @Mutation
  setAlertSuccess(payload: boolean) {
    this.alertSuccess = payload;
  }

  @Mutation
  setAlertError(payload: boolean) {
    this.alertError = payload;
  }
}
